import React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
};

export default function Toolbar({ children, className = '' }: Props) {
  return (
    <div className={`ui-toolbar filter-card ${className}`.trim()} role="toolbar">
      {children}
    </div>
  );
}
